import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import "./DataExportFilterModal.Styles.css";
import Select from 'react-select';
import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import { DATA_EXPORT } from "../../../API/url";
import { BASE_URL } from "../../../API/url";
import VizButton from "../../VizButtons/VizButton";
import VizParagraph from "../../VizParagraph/VizParagraph";
import MultiSelect from '../../MultiSelect/MultiSelect';



export default function DataExportFilterModal() {
	const modalState = useSelector((state) => state.domain);
	const userState = useSelector((state) => state.user);
	const dispatch = useDispatch();
	const { advanceFilterModalToggle } = bindActionCreators(Actions, dispatch);
	var now = new Date(),
		minDate = now.toISOString().substring(0, 10);
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const [domainName, setDomainName] = useState([]);
	const state = useSelector(state=>state.cmRoot);
	const [getId, setId] = useState([])

	const onChangeStartDate = (e) => {
		setStartDate(e.target.value)
	}

	const onChangeEndDate = (e) => {
		setEndDate(e.target.value)
	}

	const onChangeDomain = (value) => {
		setDomainName(value)
		setId(value.map((obj) => {
			return obj.indexId
		})
		)
	}


	function filteredDate(value) {
		var d = new Date(value),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

		if (month > 12) {
			let extra = month - 12;
			month = extra;
			year = year + 1;
		}
		month = month.toString();
		if (month.length < 2) {
			month = '0' + month;
		}
		if (day.length < 2) {
			day = '0' + day;
		}
		let date2 = [year, month, day].join('-');
		return date2.toString();
	}

	// https://stage.vizerto.com/cmuser/group/1/dataexport?type=searchsuggestions&status=answered&showanswer=true&levelid=3&levelvalue=&starttime=2023-12-10&endtime=2023-12-12%2023:59:59&timezone=Asia/Calcutta&domains=0%2C1%2C2%2C3%2C4%2C5%2C6%2C7%2C8%2C9%2C10%2C11%2C21%2C22%2C23%2C24%2C25

	const onClickSubmit = () => {
		// 		window.open(// window.open(comonUrl+`&levelid=${levelObj.geoLevelId}&levelvalue=${levelObj.geoLevelValue}`+startTimeParam+endTimeParam+`&timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`+domainParam, '_blank');
		// )
		// let startDate1 = filteredDate(startDate);
		// let endDate1 = filteredDate(endDate);
		let newBaseUrl = BASE_URL.replace(/'/g, '');
		var newYear = new Date();
		var getYearValue = newYear.getFullYear();
		// window.open(newBaseUrl + DATA_EXPORT("searchsuggestions").replace(/'/g, '') + `&status=answered&showanswer=true&levelid=${state.selecetdRoutingValue}` + `${state.selectedGeoLevel.name === '' ? "&levelvalue=" : `&levelvalue=${state.selectedGeoLevel.name === undefined ? "" : state.selectedGeoLevel.name}`}` + `&starttime=` + startDate + `&endtime=` + endDate + `%2023:59:59&timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}` + `${state.selectedDomainIds !== '' ? `&domains=${state.selectedDomainIds}` : `&domains=`}`, '_blank')		
		window.open(newBaseUrl + DATA_EXPORT("searchsuggestions").replace(/'/g, '')
			+ `&status=answered&showanswer=true&levelid=${state.selecetdRoutingValue}` +
			`${state.selectedGeoLevel.name === ''
				? "&levelvalue="
				: `&levelvalue=${state.selectedGeoLevel.name === undefined
					? ""
					: state.selectedGeoLevel.name}`}` +
			`${startDate !== '' ? `&starttime=${startDate}` : ""}` +
			`${endDate !== '' ? `&endtime=${endDate}` : ""}`
			+
			`${endDate !== '' ? `%2023:59:59` : ``}` + `&timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`
			+ `${getId.length > 0 
				?
				`&domains=${getId.toString()}` :
				`&domains=${state.selectedDomainIds}`}`, '_blank')
		advanceFilterModalToggle({ bool: false, value: '' })
	}

	const onClickCancel = () => {
		advanceFilterModalToggle({bool:false,value:""})
	}

	let output = Object.keys(userState.cmTopics !== undefined && userState.cmTopics).map((k) => userState.cmTopics[k]);
	var newOutput = output.map((dom) => { return { value: dom, label: dom } })

	return (
		<>
			<Modal show={modalState.modalState}
				onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
				centered={true}
				// size={"md"}
				dialogClassName="dataExportClassName"
				backdrop="static"
				>
				<Modal.Header
					className="modalHeaderBackground"
					closeButton
					closeVariant="white"
				>
					<Modal.Title className="modalTitle">
						<i class="fa fa-files-o" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Data Export
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{/* <Grid padding={1} whiteSpace="normal" container alignItems="baseline">
						<Grid item xs={2}>
							<VizParagraph weight={1} type={5}>
							Date:
							</VizParagraph>
						</Grid>
						<Grid sx={{ display: 'flex',alignItems:'center' }} item xs={7}>
							<VizParagraph weight={1} type={5}>From:</VizParagraph><input max={minDate} value={startDate} onChange={(e) => onChangeStartDate(e)} type="date" style={{ fontWeight:'100', padding:'3px', borderRadius:'3px', color:'inherit',margin: '5px', fontSize: '12px',border:'1px solid lightgray' }}></input>
							<VizParagraph weight={1} type={5}>To:</VizParagraph><input max={minDate} min={startDate} value={endDate === "" ? startDate : endDate} onChange={(e) => onChangeEndDate(e)} style={{ fontWeight:'100', padding:'3px', borderRadius:'3px', color:'inherit',margin: '5px', fontSize: '12px',border:'1px solid lightgray' }} type="date"></input>
						</Grid>
					</Grid> */}
					<div style={{ display: 'flex', flexWrap: 'wrap',justifyContent:'space-between',alignItems:'baseline' }}>
						<div>
							<VizParagraph weight={1} type={5}>
								Date:
							</VizParagraph>
						</div>
						<div>
							<VizParagraph weight={1} type={5}>From:</VizParagraph><input max={minDate} value={startDate} onChange={(e) => onChangeStartDate(e)} type="date" style={{ fontWeight: '100', padding: '3px', borderRadius: '3px', color: 'inherit', margin: '5px', fontSize: '12px', border: '1px solid lightgray' }}></input>
							<VizParagraph weight={1} type={5}>To:</VizParagraph><input max={minDate} min={startDate} value={endDate === "" ? startDate : endDate} onChange={(e) => onChangeEndDate(e)} style={{ fontWeight: '100', padding: '3px', borderRadius: '3px', color: 'inherit', margin: '5px', fontSize: '12px', border: '1px solid lightgray' }} type="date"></input>
						</div>
					</div>
					<Grid container alignItems="baseline" padding={1}>
						{/* <Grid item xs={2}>
							<VizParagraph weight={1} type={5}>
							Domains:
							</VizParagraph>
						</Grid> */}
						<Grid item xs={7}>
							{/* <Select
								defaultValue={newOutput[0]}
								isMulti
								name="domains"
								options={newOutput}
								className="basic-multi-select"
								classNamePrefix="select"
								styles={{ fontSize: '12px' }}
								onChange={onChangeDomain}
								value={domainName}
								classNames={{

								}}
							/> */}
							{/* <div style={{width:'100%'}}>
							<MultiSelect value={domainName} onChangeFunc={onChangeDomain} isMulti={true} />
							</div> */}
						</Grid>
					</Grid>
					<div style={{ display: 'flex',columnGap:'8%', flexWrap: 'wrap',alignItems:'baseline' }}>
						<div style={{paddingBottom:'13px'}}>
							<VizParagraph weight={1} type={5}>
								Domains:
							</VizParagraph>
						</div>
						<div>
						<MultiSelect value={domainName} onChangeFunc={onChangeDomain} isMulti={true} />
						</div>
					</div>
					{/* <Grid container padding={1}>
						<Grid item xs={2}>
						</Grid>
						<Grid item xs={7} >
							<Box display="flex" width="100%" justifyContent="flex-end" alignItems="baseline">
								<div style={{margin:'5px'}}>
								<VizButton size={3} type={"Primary"} onClick={onClickSubmit}>Submit</VizButton>
								</div>
								<div style={{margin:'5px'}}>
								<VizButton size={3} type={"Tertiary"} onClick={onClickCancel}>Cancel</VizButton>
								</div>
							</Box>
						</Grid>
					</Grid> */}
					<div style={{display:'flex',flexWrap:'wrap',justifyContent:'flex-end'}}>
					<div style={{display:'flex'}}>
					<div style={{margin:'3px'}}><VizButton size={3} type={"Primary"} onClick={onClickSubmit}>Submit</VizButton></div>
					<div style={{margin:'3px'}}><VizButton size={3} type={"Tertiary"} onClick={onClickCancel}>Cancel</VizButton></div>
					</div>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}